import { gql } from "@apollo/client"
export const GET_COMPANY_SESSION_CATEGORIES = gql`
query GetCompanySessionCategories($id: UUID!) {
  company(id: $id) {
    companySessionCategories {
      rankings {
        questionId
        groupKey
        questionTitle
        rankings {
          rank
          categoryType
          categoryTitle
          total
        }
      }
    }
  }
}`

